import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Home, CalendarDays, BookMarked, Users, MessageSquare, LogOut } from "lucide-react";
import logo from "@/assets/logo.png";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/admin/properties", label: "Properties", icon: Home, testid: "nav-properties" },
  { to: "/admin/calendar", label: "Calendar", icon: CalendarDays, testid: "nav-calendar" },
  { to: "/admin/bookings", label: "Bookings", icon: BookMarked, testid: "nav-bookings" },
  { to: "/admin/guests", label: "Guests", icon: Users, testid: "nav-guests" },
  { to: "/admin/inquiries", label: "Inquiries", icon: MessageSquare, testid: "nav-inquiries" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#FDFBF7]">
      <aside className="w-64 shrink-0 bg-[#F4F1EA] border-r border-black/5 flex flex-col fixed h-screen" data-testid="sidebar">
        <div className="px-4 py-6 flex items-center justify-center">
          <img src={logo} alt="Magical Villas Orlando — Luxury Homes" className="h-32 w-auto" />
        </div>
        <nav className="flex-1 px-4 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? "bg-[#1A365D] text-white" : "text-gray-600 hover:bg-[#E3D5CA]/50 hover:text-[#1A365D]"
                }`
              }
            >
              <l.icon strokeWidth={1.5} size={20} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-black/5">
          <div className="flex items-center gap-3 px-2 mb-3">
            <div className="w-9 h-9 rounded-full bg-[#1A365D] text-white flex items-center justify-center font-semibold text-sm">
              {(user?.name || "M").charAt(0)}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-[#1A365D] truncate">{user?.name || "Manager"}</p>
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
            </div>
          </div>
          <button
            data-testid="logout-button"
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-4 py-2 rounded-xl text-sm text-gray-600 hover:bg-[#E07A5F] hover:text-white transition-colors"
          >
            <LogOut strokeWidth={1.5} size={18} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-6 sm:p-8 lg:p-12 animate-in fade-in duration-500">{children}</main>
    </div>
  );
}
